module.exports = __webpack_public_path__ + "static/caraCrop-1a22e82f88b37e7fd8c8aa2ee3d7731e.jpg";